import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import WeezBoRoute from '../../components/migrations/weezRoute';
import Bank from './bank';
import OrganizerProfile from './organizerProfile';
import Settings from './settings';
import BankModel from '../../models/bank';
import { fetcher } from '@weezevent/weezjs-core';
import Accounting from './accounting';
import AuthRoute from '../../utils/authRoute';
import Transfers from './transfers';
import PageError from '../error/pageError';
import Affiliation from '../../pages/affiliation';

export default function Organization({ path, organization, match: { url } }) {
    const [bank, setBank] = React.useState({});
    const [orgaSettings, setOrgaSettings] = React.useState({});
    React.useEffect(() => {
        const endpoint = `/ticket/organizations/${organization.id}/settings/account`;
        fetcher
            .get(endpoint, { cache: false })
            .then(({ response }) => {
                setOrgaSettings(response);
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {});

        BankModel.get({ id: organization.id })
            .then(bank => {
                setBank(bank);
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {});
    }, [organization.id]);
    return (
        <Switch>
            <Route
                exact
                path={`${path}/`}
                render={() => {
                    let redirect = `${url}/organization/profile`;
                    if (url[url.length - 1] === '/') {
                        redirect = `${url}organization/profile`;
                    }

                    return <Redirect to={redirect} />;
                }}
            />
            <AuthRoute
                exact
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.ORGANIZATION']}
                path={`${path}/profile`}
                fallback={<PageError errorCode={403} backHomeUrl={`/ticket/O${organization.id}`} />}
                render={({ match, history }) => {
                    return <OrganizerProfile organization={organization} bank={bank} />;
                }}
            />
            <AuthRoute
                exact
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.BANK']}
                path={`${path}/bank`}
                fallback={<PageError errorCode={403} backHomeUrl={`/ticket/O${organization.id}`} />}
                render={({ match, history }) => {
                    return <Bank organization={organization} bank={bank} setBank={setBank} />;
                }}
            />
            <AuthRoute
                exact
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.ORGANIZATION']}
                path={`${path}/settings`}
                fallback={<PageError errorCode={403} backHomeUrl={`/ticket/O${organization.id}`} />}
                render={({ match, history }) => {
                    return <Settings organization={organization} bank={bank} orgaSettings={orgaSettings} />;
                }}
            />
            <AuthRoute
                exact
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.ACCOUNTING']}
                path={`${path}/accounting`}
                fallback={<PageError errorCode={403} backHomeUrl={`/ticket/O${organization.id}`} />}
                render={({ match, history }) => {
                    return <Accounting organization={organization} bank={bank} orgaSettings={orgaSettings} />;
                }}
            />
            <AuthRoute
                exact
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.TRANSFERS']}
                path={`${path}/transfers`}
                fallback={<Redirect to={`/ticket/O${organization.id}/organization/transfers/redirect`} />}
                render={({ match, history }) => {
                    return <Transfers organization={organization} bank={bank} orgaSettings={orgaSettings} />;
                }}
            />

            {/* Affiliation */}
            <AuthRoute
                allow={['PyvarCapacity.ADMIN', 'PyvarCapacity.AFFILIATION']}
                path={`${path}/affiliation`}
                render={() => <Affiliation menhirUrl={`${window.weezConfig.temporary.menhirUrl}/bo/mon_compte_affiliation.php`} />}
            />

            <WeezBoRoute path={`${path}/transfers/redirect`} weezRoute={`${window.weezConfig.temporary.menhirUrl}/bo/mon_compte_historique.php`} />
            <WeezBoRoute path={`${path}/accounting/redirect`} weezRoute={`${window.weezConfig.temporary.menhirUrl}/bo/mon_compte_reddition.php`} />
            <WeezBoRoute path={`${path}/myprofile`} weezRoute={`${window.weezConfig.temporary.menhirUrl}/bo/mon_compte.php`} />

            {/* Error */}
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}

Organization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired,
    match: PropTypes.object.isRequired
};
